module.exports = __webpack_public_path__ + "img/icon-settings-medio.3a48e208.svg";